import React from 'react';
import { TransparentBg, ModalBody, Header, Title, CloseModalButton } from './styled';
import { ReactComponent as XIcon } from 'assets/icons/ui-elements/small/x-mark-sm.svg';

export interface FormModalProps {
  setClose: (value: boolean) => void;
  title?: string;
  children?: React.ReactNode;
}

export const FormModal: React.FC<FormModalProps> = ({ setClose, title, children }) => {
  return (
    <TransparentBg>
      <ModalBody>
        <Header>
          <Title>{title}</Title>
          <CloseModalButton onClick={() => setClose(false)}>
            <XIcon />
          </CloseModalButton>
        </Header>
        {children}
      </ModalBody>
    </TransparentBg>
  );
};
